"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _actions = _interopRequireDefault(require("../../../elements/other/actions"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-nested-ternary */

/**
 * Local Imports
 */

const SharedStyles = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SharedStyles",
  class: "pl-s1a5nusy"
});
const SearchContainer = /*#__PURE__*/(0, _react2.styled)(SharedStyles)({
  name: "SearchContainer",
  class: "pl-s9fchps"
});
const ResultsWrapper = /*#__PURE__*/(0, _react2.styled)(SharedStyles)({
  name: "ResultsWrapper",
  class: "pl-r12eyp51",
  vars: {
    "r12eyp51-0": [({
      status
    }) => status === 'Error' ? `${_intents.default.ux.feedbackCritical.feedbackColor}` : `${_intents.default.ux.actionOptionChosen.borderColor}`]
  }
});
const IconContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconContainer",
  class: "pl-ike78mq"
});
const ResultsContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ResultsContainer",
  class: "pl-r1ff2o2a"
});

/**
 * SSLCheckerForm Component.
 *
 * @param {String} props.id Form Id
 * @param {String} props.noCertText A text if has no certificate
 * @param {String} props.invalidCertText A text if has invalid certificate
 * @param {String} props.siteNotFoundText A text if has site not found
 * @param {String} props.siteSecureText A text if has secure
 * @param {String} props.generalFailureText A text if unable to resolve
 * @param {String} props.placeholder Input placeholder text
 * @param {String} props.buttonLoadingText Button progress state text
 * @param {String} props.buttonText Button text
 * @returns {React.ReactElement} SSLCheckerForm Component
 * @public
 */

function SSLCheckerForm({
  id,
  noCertText,
  invalidCertText,
  siteNotFoundText,
  siteSecureText,
  generalFailureText,
  placeholder = 'domainname.com',
  buttonLoadingText,
  buttonText
}) {
  const [formData, setFormData] = (0, _react.useState)({
    domain: '',
    isLoading: false,
    result: null
  });
  const handleDomainChange = value => {
    const newDomain = value.replace(/^https?:\/\//, '').replace(/\/$/, '');
    setFormData(prevFormData => ({
      ...prevFormData,
      domain: newDomain
    }));
  };

  // eslint-disable-next-line complexity
  const processSSLData = data => {
    if (data.error) {
      setFormData({
        ...formData,
        isLoading: false,
        result: {
          status: 'Error',
          message: siteNotFoundText
        }
      });
    } else if (!data.certChain) {
      setFormData({
        ...formData,
        isLoading: false,
        result: {
          status: 'Error',
          message: noCertText
        }
      });
    } else if (data.certificateDuration === 'Expired' || data.OCSPStatus === 'Revoked' || data.certChain?.error?.includes('handshake failure') || data.certificateHostName && data.certificateHostName.hostnameMismatch) {
      setFormData({
        ...formData,
        isLoading: false,
        result: {
          status: 'Error',
          message: invalidCertText
        }
      });
    } else if (data.certChain?.error && (data.certificateDuration?.includes('Could not retrieve') || data.certificateHostName?.includes('Could not retrieve') || data.OCSPStatus?.includes('Unable to verify'))) {
      setFormData({
        ...formData,
        isLoading: false,
        result: {
          status: 'Error',
          message: generalFailureText
        }
      });
    } else {
      setFormData({
        ...formData,
        isLoading: false,
        result: {
          message: siteSecureText
        }
      });
    }
  };
  const checkSSL = async e => {
    e.preventDefault();
    if (!formData.domain) {
      setFormData({
        ...formData,
        result: {
          status: 'Error',
          message: siteNotFoundText
        }
      });
      return;
    }
    setFormData({
      ...formData,
      isLoading: true,
      result: null
    });
    const endpointUrl = 'https://ssltools.godaddy.com/cert/check';
    const postData = JSON.stringify({
      url: encodeURIComponent(formData.domain)
    });
    try {
      const response = await fetch(endpointUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: postData
      });
      if (!response.ok) {
        throw new Error('Failed to fetch the SSL certificate details.');
      }
      const data = await response.json();
      processSSLData(data);
    } catch (error) {
      setFormData({
        ...formData,
        isLoading: false,
        result: {
          status: 'Error',
          message: generalFailureText
        }
      });
    }
  };
  const inputBar = {
    id: id,
    _name: 'ssl-check-submit',
    disabled: formData.isLoading,
    clearable: true,
    initialValue: formData.domain,
    placeholder: placeholder,
    ariaInputLabel: 'ssl-cert-search',
    ariaButtonLabel: 'submit',
    handleOnChange: handleDomainChange,
    button: {
      text: `${formData.isLoading ? buttonLoadingText || buttonText : buttonText}`,
      disabled: formData.isLoading
    }
  };
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: checkSSL,
    name: "ssl-check-form",
    "aria-live": "polite"
  }, /*#__PURE__*/_react.default.createElement(SearchContainer, null, /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "input-bar",
    ctas: [inputBar]
  })), /*#__PURE__*/_react.default.createElement("div", null, formData.result && /*#__PURE__*/_react.default.createElement(ResultsWrapper, {
    status: formData.result?.status
  }, /*#__PURE__*/_react.default.createElement(IconContainer, null, formData.result?.status === 'Error' ? /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "alert"
  }) : /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "locked"
  })), /*#__PURE__*/_react.default.createElement(ResultsContainer, null, formData.result?.message && /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    className: "h6",
    text: formData.result.message
  })))));
}
var _default = exports.default = SSLCheckerForm;
SSLCheckerForm.propTypes = {
  id: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  noCertText: _propTypes.default.string,
  invalidCertText: _propTypes.default.string,
  siteSecureText: _propTypes.default.string,
  siteNotFoundText: _propTypes.default.string,
  generalFailureText: _propTypes.default.string,
  buttonLoadingText: _propTypes.default.string,
  buttonText: _propTypes.default.string
};